import { TipoUrlFacturaFirma } from '../enums/TipoUrlFacturaFirmada.enum';
import { FacturaModel } from './factura.model';

export class UrlFacturaFirmadaModel {
  url: string;
  tipo: TipoUrlFacturaFirma;
}
